import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthGate } from '@/auth/AuthGate';
import { Layout } from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';
import { AuditPage } from '@/pages/AuditPage';
import { BillingPage } from '@/pages/BillingPage';
import { DLQPage } from '@/pages/DLQPage';
import { ForceCancelPage } from '@/pages/ForceCancelPage';
import { OrgDetailPage } from '@/pages/OrgDetailPage';
import { OrgsPage } from '@/pages/OrgsPage';
import { SandboxesPage } from '@/pages/SandboxesPage';

export function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthGate>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/orgs" replace />} />
            <Route path="/orgs" element={<OrgsPage />} />
            <Route path="/orgs/:id" element={<OrgDetailPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/dlq" element={<DLQPage />} />
            <Route path="/sandboxes" element={<SandboxesPage />} />
            <Route path="/force-cancel" element={<ForceCancelPage />} />
            <Route path="*" element={<Navigate to="/orgs" replace />} />
          </Route>
        </Routes>
      </AuthGate>
      <Toaster richColors closeButton />
    </BrowserRouter>
  );
}
